var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTasks(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    "data-bbox": "1.1 -0.014 197.8 200.114",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "1.1 -0.014 197.8 200.114",
    role: "presentation",
    "aria-hidden": "true",
    fill: "current",
    stroke: "current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M71.4.9L53.9 14.8V11c0-2.4-2-4.4-4.4-4.4h-44c-2.4 0-4.4 2-4.4 4.4v44c0 2.4 2 4.4 4.4 4.4h44c2.4 0 4.4-2 4.4-4.4V26l23-18.1c1.9-1.5 2.2-4.3.7-6.2S73.3-.6 71.4.9zM45.1 21.7L31 32.7l-6-12.3c-1.1-2.2-3.7-3.1-5.9-2s-3.1 3.7-2 5.9l8.4 17.2c.6 1.2 1.7 2.1 3 2.4.3.1.7.1 1 .1 1 0 1.9-.3 2.7-.9l12.9-10.2v17.7H9.9V15.4h35.2v6.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4 71.3L53.9 85.1v-3.8c0-2.4-2-4.4-4.4-4.4h-44c-2.4 0-4.4 2-4.4 4.4v44c0 2.4 2 4.4 4.4 4.4h44c2.4 0 4.4-2 4.4-4.4v-29l23-18.1c1.9-1.5 2.2-4.3.7-6.2-1.5-1.9-4.3-2.2-6.2-.7zM45.1 92L31 103.1l-6-12.3c-1.1-2.2-3.7-3.1-5.9-2s-3.1 3.7-2 5.9l8.4 17.2c.6 1.2 1.7 2.1 3 2.4.3.1.7.1 1 .1 1 0 1.9-.3 2.7-.9l12.9-10.2V121H9.9V85.7h35.2V92z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5 147.3h-44c-2.4 0-4.4 2-4.4 4.4v44c0 2.4 2 4.4 4.4 4.4h44c2.4 0 4.4-2 4.4-4.4v-44c0-2.5-2-4.4-4.4-4.4zm-4.4 43.9H9.9V156h35.2v35.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.5 156H97.8c-2.4 0-4.4 2-4.4 4.4s2 4.4 4.4 4.4h96.7c2.4 0 4.4-2 4.4-4.4s-2-4.4-4.4-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.5 182.4H97.8c-2.4 0-4.4 2-4.4 4.4s2 4.4 4.4 4.4h96.7c2.4 0 4.4-2 4.4-4.4s-2-4.4-4.4-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.5 85.7H97.8c-2.4 0-4.4 2-4.4 4.4s2 4.4 4.4 4.4h96.7c2.4 0 4.4-2 4.4-4.4s-2-4.4-4.4-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.5 112.1H97.8c-2.4 0-4.4 2-4.4 4.4s2 4.4 4.4 4.4h96.7c2.4 0 4.4-2 4.4-4.4s-2-4.4-4.4-4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8 24.2h96.7c2.4 0 4.4-2 4.4-4.4s-2-4.4-4.4-4.4H97.8c-2.4 0-4.4 2-4.4 4.4s2 4.4 4.4 4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.5 41.8H97.8c-2.4 0-4.4 2-4.4 4.4s2 4.4 4.4 4.4h96.7c2.4 0 4.4-2 4.4-4.4s-2-4.4-4.4-4.4z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasks);
export default __webpack_public_path__ + "static/media/tasks.d65f2297.svg";
export { ForwardRef as ReactComponent };